import React from 'react';
import { useSelector } from 'react-redux';
import { Container, Row, Col, Carousel } from 'react-bootstrap';
import { Link } from 'react-router-dom';

// Own constants/actions/components
import { results, resData } from 'services/selectors/filters';
import CardInfo from 'components/cards';
import LoaderCP from 'components/loader';

const ExperienciesSection = () => {
  const resApi = useSelector(results);
  const resultsData = useSelector(resData);

  // Splits an array into chunks for a new array
  // Speciffically, we get one array and re-pack the elements
  // into a new array of up to `maxChunkSize` elements each:
  // for example - assuming maxChunkSize = 4 we have
  // [ a,b,c,d,e,f,g,h,i,j ] => [ [a,b,c,d], [e,f,g,h], [i,j] ]
  const chunkDesktopCarousel = (data) => {
    const maxChunkSize = 3;
    return data.reduce((resultArray, item, index) => {
      const chunkIndex = Math.floor(index / maxChunkSize);

      if (!resultArray[chunkIndex]) {
        // eslint-disable-next-line no-param-reassign
        resultArray[chunkIndex] = [];
      }

      resultArray[chunkIndex].push(item);

      return resultArray;
    }, []);
  };

  const renderBody = () => {
    const dataFilter = resultsData.results.experiences.filter((exp) => exp.isRecommended === true);

    return (
      dataFilter.length > 0 ? (
        <Container id="experiencias-recomendadas">
          <Row className="justify-content-center pt-60">
            <Col lg={12}>
              <h2 className="text-center text-midnight-blue ft-28">Experiencias recomendadas</h2>
            </Col>
          </Row>
          <Carousel className="with-controls d-none d-lg-block d-xl-block mb-0" controls={dataFilter.length > 3}>
            {
              chunkDesktopCarousel(dataFilter).map((row, index) => {
                // We dont really have another way of id'ing these rows...
                const rowKey = `row-${index}`;
                return (
                  <Carousel.Item key={rowKey}>
                    <Row className="justify-content-center pt-15 pb-60">
                      {
                        row.map((e) => {
                          return (
                            <Col md={3} key={e.id} className="d-flex justify-content-center">
                              <Link to={`${e.pathName}/${e.id}`} className="not-link">
                                <CardInfo
                                  key={e.id}
                                  recommend
                                  stock={e.stock}
                                  image={e.imageUrl}
                                  title={e.title}
                                  place={e.location}
                                  points={e.cost}
                                  pointsWithDisscount={e.costWithDisscount}
                                  textlabel={e.category.name}
                                  nameCode={e.category.nameCode} />
                              </Link>
                            </Col>
                          );
                        })
                      }
                    </Row>
                  </Carousel.Item>
                );
              })
            }
          </Carousel>
          <Carousel indicators={false} className="with-controls d-lg-none d-xl-none" controls={dataFilter.length > 1}>
            {
              dataFilter.map((e) => {
                return (
                  <Carousel.Item key={e.id}>
                    <Link to={`${e.pathName}/${e.id}`} className="not-link">
                      <CardInfo
                        key={e.id}
                        recommend
                        stock={e.stock}
                        image={e.imageUrl}
                        title={e.title}
                        place={e.location}
                        points={e.cost}
                        pointsWithDisscount={e.costWithDisscount}
                        textlabel={e.category.name}
                        nameCode={e.category.nameCode} />
                    </Link>
                  </Carousel.Item>
                );
              })
            }
          </Carousel>
        </Container>
      ) : ''
    );
  };

  return (
    <Container fluid>
      { resApi.isFetching ? <LoaderCP /> : '' }
      { resApi.error ? '' : '' }
      { resultsData && resultsData.results
        && resultsData.results.categories
        && resultsData.results.experiences
        && resApi.isFetching === false
        ? renderBody()
        : '' }
    </Container>
  );
};

export default ExperienciesSection;
